import { Helpers } from '../../helpers';
import { ITownship } from '../../interfaces/itownship';
import { Asset } from '../asset';
import { Lease } from '../lease';
import { Well } from '../well';

export class TownshipBase {
  TownshipId: number;
  Description: string | null;
  Shape: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Assets_Township?: Array<Asset> | null;
  Leases_Township?: Array<Lease> | null;
  Wells_Township?: Array<Well> | null;

  constructor(item?: ITownship) {
    if (item) {

      this.TownshipId = item.TownshipId;
      this.Description = item.Description;
      this.Shape = item.Shape;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Assets_Township = Helpers.createClassArray(Asset, item.Assets_Township);
      this.Leases_Township = Helpers.createClassArray(Lease, item.Leases_Township);
      this.Wells_Township = Helpers.createClassArray(Well, item.Wells_Township);
    }
  }
}